// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__12o_y","header":"Messages_header__3iKok"};